import { Component, inject, Inject } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { selectIsAdmin, selectIsDeveloper } from 'src/app/auth/store/session/session.selectors';
import { SnackbarData } from 'src/app/core/models/snackbar.model';

@Component({
  selector: 'app-shared-snackbar',
  templateUrl: 'snackbar.component.html',
  styleUrls: ['snackbar.component.scss'],
  standalone: false
})
export class SharedSnackbarComponent {
  isAdmin: Observable<boolean>;
  isDeveloper: Observable<boolean>;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: SnackbarData, private store: Store) {
    this.isAdmin = this.store.select(selectIsAdmin);
    this.isDeveloper = this.store.select(selectIsDeveloper);
  }

  snackBarRef = inject(MatSnackBarRef);
  baseUrl = window.location.origin;

  closeSnackbar() {
    this.snackBarRef.dismiss();
  }
}
